import { FunctionComponent, ReactNode } from "react";

import { Button } from "@/components/Button/Button";
import { ButtonColor } from "@/components/Button/types";

/**
 * One seat add-on card on the Usage overview (PREC-3714). The LinkedIn and email cards were
 * copy-pasted twins, which is how their labels drifted apart — the LinkedIn one ended up never
 * naming LinkedIn while still billing the LinkedIn add-on. One component, two call sites.
 */
export const SenderSeatCard: FunctionComponent<{
	title: string;
	used: number;
	total: number;
	usedLabel: string;
	bonusAmount: number;
	/** A pending decrease, expressed as a paid amount — the base is added back for display. */
	pendingAmount?: number | null;
	pendingEffectiveAt?: string | null;
	baseAmount: number;
	connectedRow: ReactNode;
	buttonTitle: string;
	buttonDisabled: boolean;
	onButtonClick: () => void;
}> = ({
	title,
	used,
	total,
	usedLabel,
	bonusAmount,
	pendingAmount,
	pendingEffectiveAt,
	baseAmount,
	connectedRow,
	buttonTitle,
	buttonDisabled,
	onButtonClick,
}) => (
	<div className="flex flex-col rounded-xl border border-gray-200 bg-brand-white p-5">
		<div className="text-sm font-semibold mb-3">{title}</div>
		<div className="flex items-center gap-2 text-lg font-bold mb-3">
			{used}/{total} <span className="text-sm font-normal text-gray-500">{usedLabel}</span>
			{bonusAmount > 0 && (
				<span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full font-normal">
					+{bonusAmount} bonus
				</span>
			)}
		</div>

		{pendingAmount !== null && pendingAmount !== undefined && (
			<div className="rounded-md bg-yellow-50 p-2 text-xs text-yellow-700 mb-3">
				Pending change: Seats will decrease to <b>{pendingAmount + baseAmount}</b> on{" "}
				{pendingEffectiveAt
					? new Date(pendingEffectiveAt).toLocaleDateString("de-DE", {
							day: "2-digit",
							month: "2-digit",
							year: "numeric",
						})
					: ""}
				.
			</div>
		)}

		<div className="flex flex-col gap-2 mb-4 text-sm text-gray-600">{connectedRow}</div>

		<div className="mt-2">
			<Button
				color={ButtonColor.ACTION_SECONDARY}
				disabled={buttonDisabled}
				title={buttonTitle}
				onClick={onButtonClick}
			/>
		</div>
	</div>
);
